<mat-dialog-content>
Do you confirm?
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>No</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Yes</button>
</mat-dialog-actions>
